import apiClient from "@/api/client";
import type { TaskComment } from "@/features/tasks/types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

export const commentsApi = {
  list: (taskId: string) =>
    apiClient.get<{ data: TaskComment[] }>(`/tasks/${taskId}/comments/`).then(wrap),

  create: (taskId: string, content: string, mentionIds: string[] = [], replyTo?: string | null) =>
    apiClient
      .post<{ data: TaskComment }>(`/tasks/${taskId}/comments/`, {
        content,
        mention_ids: mentionIds,
        ...(replyTo ? { reply_to: replyTo } : {}),
      })
      .then(wrap),

  update: (taskId: string, id: string, content: string, mentionIds?: string[]) =>
    apiClient.patch<{ data: TaskComment }>(`/tasks/${taskId}/comments/${id}/`, { content, ...(mentionIds ? { mention_ids: mentionIds } : {}) }).then(wrap),

  delete: (taskId: string, id: string) =>
    apiClient.delete(`/tasks/${taskId}/comments/${id}/`),

  uploadCommentImage: (taskId: string, file: File): Promise<string> => {
    const form = new FormData();
    form.append("file", file);
    return apiClient
      .post<{ data: { url: string } }>(`/tasks/${taskId}/comments/upload-image/`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data.data.url);
  },

  uploadDescriptionImage: (taskId: string, file: File): Promise<string> => {
    const form = new FormData();
    form.append("file", file);
    return apiClient
      .post<{ data: { url: string } }>(`/tasks/${taskId}/upload-description-image/`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data.data.url);
  },
};
